"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarLabels;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _localeLanguageDays = require("./localeLanguageDays");
function CalendarLabels(_ref) {
  let {
    labels,
    language
  } = _ref;
  return labels.map((label, idx) => /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      "Calendar-label": true,
      "t-label-med": true,
      "Calendar-label--weekend": idx === 0 || idx === 6,
      "Calendar-label--chinese t-label-small": language === _localeLanguageDays.userLanguages.zh
    }),
    key: label
  }, label));
}